import React, { useState, FC } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';

interface IProps {
  isInvalid?: boolean;
  isDisabled?: boolean;
  height?: '96' | '296' | '108';
  className?: string;
  placeholder: string;
  resizableByContent?: boolean;
  [restProps: string]: any;
}

const Textarea: FC<IProps> = ({
  isInvalid,
  isDisabled,
  height,
  className,
  placeholder,
  resizableByContent,
  ...restProps
}) => {
  const [dynamicFieldHeight, setDynamicFieldHeight] = useState<'auto' | number>(Number(height));

  function onKeyUp({ target }: React.KeyboardEvent<HTMLTextAreaElement>) {
    if (resizableByContent) {
      setDynamicFieldHeight('auto');
      setTimeout(() => {
        setDynamicFieldHeight((target as HTMLTextAreaElement).scrollHeight);
      }, 1);
    }
  }

  return (
    <textarea
      placeholder={placeholder}
      onKeyUp={onKeyUp}
      style={{ height: dynamicFieldHeight === 'auto' ? 'auto' : dynamicFieldHeight + 'px' }}
      className={classNames(
        css.textarea,
        {
          [css.isDisabled]: isDisabled,
          [css.isInvalid]: isInvalid,
          [css[`textarea_height_${height}`]]: height,
        },
        className,
      )}
      disabled={isDisabled}
      {...restProps}
    />
  );
};

export default Textarea;
